import { AccessPropApi } from "../DTO/Access";
import { AccessStore } from "../Stores/AccessStore";
import { ServerClient, serverOrigin } from "./Configs";

class AccessServerClient {
  private path = "/admin/promo_code";

  sendToCreateAccessAsync = async (accessStore: AccessStore): Promise<null> => {
    await this.sendNewAccessAsync(accessStore.accessData)
      .then(() => {
        alert("Промокод успешно создан и отправлен.");
      })
      .catch((error) => {
        console.error("Ошибка:", error);
      });

    return null;
  };

  sendNewAccessAsync = async (accessData: AccessPropApi): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/create";
    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify(accessData),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };
}

let accessServerClient = new AccessServerClient();

export default accessServerClient;
